import React, { memo, useRef, useState, useLayoutEffect } from "react";

import AxiomSpinner from "__AxiomComponents/AxiomUI/AxiomSpinner/AxiomSpinner";

import "./HawkeyeV2PostComments.scss";

function HawkeyeV2PostComments(props) {
  const { comments, isFetchingComments, onAddComment, postDescription, post } = props;

  const [comment, updateComment] = useState("");

  const commentsRef = useRef(null);

  const onPostComment = () => {
    onAddComment(comment, post.emailConfiguration.onAddComment);
    updateComment("");
  };

  // Keep comment list scrolled to bottom to show new comments
  useLayoutEffect(() => {
    if (commentsRef.current) {
      commentsRef.current.scrollTop = commentsRef.current.scrollHeight;
    }
  });

  return (
    <div className="hawkeye-comments">
      {/* Post Description */}
      {postDescription && (
        <div className="hawkeye-post-description">
          <p>
            <b>Description </b>
          </p>
          <p>{postDescription}</p>
        </div>
      )}
      {/* While fetching comments */}
      {isFetchingComments && (
        <div className="hawkeye-comments-fetching">
          <AxiomSpinner spinnerWidth={24} />
          Fetching comments...
        </div>
      )}
      {/* When there are no comments */}
      {!isFetchingComments && comments.length === 0 && (
        <div className="hawkeye-comments-fetching">
          No comments yet. Post one and get the ball rolling... :)
        </div>
      )}
      <div ref={commentsRef} className="hawkeye-comment-list nice-scroll">
        {comments.map((c) => (
          <div key={c.id} className="hawkeye-comment">
            <p className="hawkeye-comment-meta">
              <b>{c.creator}</b> replied on {new Date(c.createdOn).toLocaleDateString()}
            </p>
            <p className="hawkeye-comment-message">{c.message}</p>
          </div>
        ))}
      </div>
      <div className="hawkeye-comment-add">
        <div className="hawkeye-form-group">
          <label className="hawkeye-form-label">Reply</label>
          <textarea
            rows="3"
            className="hawkeye-form-control is-full"
            onChange={(e) => updateComment(e.target.value)}
            value={comment}
          />
        </div>
        <div className="hawkeye-form-footer">
          <button
            disabled={!comment}
            className="hawkeye-btn hawkeye-btn-primary"
            onClick={onPostComment}
          >
            Post Reply
          </button>
        </div>
      </div>
    </div>
  );
}

export default memo(HawkeyeV2PostComments);
